import axios from "axios";

export const lavakleenApi = axios.create({
    baseURL: 'https://api.acquacrm.app/'
    // baseURL: 'http://108.175.5.101:8084/'
});